"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DEBUG_1 = require("@src/DEBUG");
DEBUG_1.DEBUG.open('/commons/FourDInjector.ts');
class FourDInjector {
    constructor(injector) {
        this.injector = injector;
        DEBUG_1.DEBUG.log('/commons/FourDInjector.ts', 'CONSTRUCTOR static inject', injector);
        FourDInjector.injector = injector;
    }
}
exports.FourDInjector = FourDInjector;
